import { SetStateAction } from "react";
import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";
import convertDate from "../../../utils/convertDate";

export const accessLogModal = ({
  t,
  usersList,
  updateAccessLog,
  windowValues,
  setWindowValues,
  windowValues2,
  setWindowValues2,
  updateWindowValue,
  closeMsg,
}: stdObject) => {
  const fields = [
    ["ACTIP0", "p.allowAccess"],
    ["DATIP0", "p.date"],
    ["COUIP0", "p.country"],
    ["IPIP0", "p.globalIp"],
    ["LOCIP0", "p.localIp"],
    ["DEVIP0", "p.device"],
    ["OSIP0", "p.operatingSystem"],
    ["MOBIP0", "p.mobile"],
  ];

  const getValue = (type: string) => {
    switch (type) {
      case "DATIP0":
        return convertDate({ info: windowValues[type], t });
      case "COUIP0":
        return windowValues[type] === ""
          ? t("p.unknown")
          : t(`country.${windowValues[type]}`);
      case "DEVIP0":
        return windowValues[type] === "unknown"
          ? t("p.unknown")
          : windowValues[type];
      case "MOBIP0":
        return windowValues[type] ? t("p.yes") : t("p.no");
    }
    return windowValues[type];
  };

  return {
    title: t("p.accessAttempt"),
    label: usersList[windowValues.USUIP0]?.NOMUSU ?? "aa",
    blocked: true,
    inputs: fields.map((e: string[]) => {
      return {
        label: t(e[1]),
        value: getValue(e[0]),
        type: e[0] === "ACTIP0" ? "checkbox" : "info",
        onChange:
          e[0] === "ACTIP0"
            ? (o: { target: { value: SetStateAction<string> } }) => {
                let value = o.target.value;
                updateWindowValue({
                  code: e[0],
                  value: Number(value) ? 0 : 1,
                  windowValues,
                  setWindowValues,
                  windowValues2,
                  setWindowValues2,
                });
              }
            : () => {},
      };
    }),
    buttons: [
      {
        label: t("p.update"),
        onClick: () => updateAccessLog(),
        color: colors.green,
      },
      {
        label: t("p.cancel"),
        onClick: () => closeMsg(),
        color: colors.darkGrey,
      },
    ],
  };
};
